import { createContext, useContext, useEffect, useState } from 'react';
import { FeaturesEnum } from './FeaturesEnum';
import FeatureFlagConfigService from '@services/FeatureFlagConfigService/FeatureFlagConfigService';
import { useApolloClient } from '@apollo/client';
import defaultFeatureFlags from 'HiveClient/config/FeatureFlags/FeatureFlags';
export interface FeatureFlagsConfig {
  [FeaturesEnum.Store]: boolean;
  [FeaturesEnum.Arcade]: boolean;
  [FeaturesEnum.Streams]: boolean;
  [FeaturesEnum.Wallet]: boolean;
  [FeaturesEnum.AllowAddingCurrency]: boolean;
  [FeaturesEnum.Keycloak]: boolean;
  [FeaturesEnum.StreamsOnHomePage]: boolean;
  [FeaturesEnum.UpcomingMatchTimes]?: boolean;
  [FeaturesEnum.SubscriptionsUpgrade]?: boolean;
  [FeaturesEnum.SubscriptionsUnsubscribe]?: boolean;
  [FeaturesEnum.Subscriptions]: boolean;
  [FeaturesEnum.CheckinIndicators]?: boolean;
  [FeaturesEnum.FeaturedStoreHomepage]?: boolean;
  [FeaturesEnum.StoreNavigation]?: boolean;
  [FeaturesEnum.Events]: boolean;
  [FeaturesEnum.RemoteLocalizations]?: boolean;
  [FeaturesEnum.HeaderIcons]?: boolean;
  [FeaturesEnum.StoreBrowseByGamesToBottom]?: boolean;
  [FeaturesEnum.StoreBanners]?: boolean;
  [FeaturesEnum.StoreProfile]?: boolean;
  [FeaturesEnum.FooterIcons]?: boolean;
  [FeaturesEnum.Blog]?: boolean;
  [FeaturesEnum.UnderMaintenance]?: boolean;
}
export interface FeatureFlagsContextInterface {
  updateFeatureFlags: (newFeatureFlags: FeatureFlagsConfig) => void;
  checkFeatureFlags: (featureFlag: FeaturesEnum | FeaturesEnum[]) => boolean;
  loadingFeatureFlags: boolean;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextInterface>({
  updateFeatureFlags: (_: FeatureFlagsConfig) => {},
  checkFeatureFlags: (_: FeaturesEnum | FeaturesEnum[]) => false,
  loadingFeatureFlags: false,
});

export const FeatureFlagsContextProvider = ({ children }: any) => {
  const [featureFlags, setFeatureFlags] =
    useState<FeatureFlagsConfig>(defaultFeatureFlags);
  const [loadingFeatureFlags, setLoadingFeatureFlags] = useState<boolean>(true);

  const updateFeatureFlags = (newFeatureFlags: FeatureFlagsConfig) => {
    setFeatureFlags((previousFeatureFlags) => ({
      ...previousFeatureFlags,
      ...newFeatureFlags,
    }));
  };
  const apolloClient = useApolloClient();

  const checkFeatureFlags = (featureFlag: FeaturesEnum | FeaturesEnum[]) => {
    if (Array.isArray(featureFlag)) {
      return featureFlag.every((flag) => featureFlags[flag] === true);
    }
    return featureFlags[featureFlag] ?? false;
  };

  useEffect(() => {
    setLoadingFeatureFlags(true);
    FeatureFlagConfigService.init(apolloClient)
      .then((featureFlagsConfig) => {
        if (featureFlagsConfig) {
          setFeatureFlags(featureFlagsConfig);
        }
      })
      .finally(() => {
        setLoadingFeatureFlags(false);
      });
  }, [apolloClient]);

  return (
    <FeatureFlagsContext.Provider
      value={{
        updateFeatureFlags,
        checkFeatureFlags,
        loadingFeatureFlags,
      }}
    >
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlagsContext = () => useContext(FeatureFlagsContext);
